import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(characters: any, term: any[]): any {

    /* for (const post of characters) {
      if (post.name.indexOf(term) > -1 ) {
        console.log('si');
      }
    } */

    if (term === undefined) { return characters; }

    // tslint:disable-next-line: only-arrow-functions
    return characters.filter(function(character) {
      return character.name.toLowerCase().includes(term);
    });
  }

}
